export class SafeProposalDroppedError extends Error {
  constructor(options?: ErrorOptions) {
    super(
      'Your Safe rejected or replaced the proposed transaction. Try again to propose it again.',
      options
    )
    this.name = 'SafeProposalDroppedError'
  }
}
